export interface PcsApprovalRecipient {
    forOrganization: string | null;
    terminalId: string | null;
}

export function parsePcsApprovalRecipient(selection: unknown): PcsApprovalRecipient {
    const emptyRecipient: PcsApprovalRecipient = { forOrganization: null, terminalId: null };

    if (selection !== null && typeof selection === 'object') {
        return 'id' in selection ? parsePcsApprovalRecipient((selection as { id?: unknown }).id) : emptyRecipient;
    }

    const selectionId =
        typeof selection === 'number' && Number.isFinite(selection)
            ? selection.toString()
            : typeof selection === 'string'
            ? selection.trim()
            : null;

    if (!selectionId) {
        return emptyRecipient;
    }

    const separatorIndex = selectionId.lastIndexOf(' -');
    const forOrganization = (separatorIndex < 0 ? selectionId : selectionId.slice(separatorIndex + 2)).trim();
    const terminalId = separatorIndex < 0 ? null : selectionId.slice(0, separatorIndex).trim();

    if (!/^\d+$/.test(forOrganization) || (separatorIndex >= 0 && !terminalId)) {
        return emptyRecipient;
    }

    return { forOrganization, terminalId };
}
